module.exports = __webpack_public_path__ + "img/vip_title3.1e220460.png";